import React, { useEffect, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Fade from '@material-ui/core/Fade'

// components
import Loading from './Loading'
import Agreement from './Agreement'

// store
import { Context } from '../store'

// API
import { getClubUserAgreement, getToken } from '../API'
import types from '../store/types'

// styles
const useStyles = makeStyles({
  wrapper: {
    background: '#fff',
    padding: '2.5rem 2.5rem 3.75rem',
    flexGrow: 1,
  },
  content: {
    maxWidth: 400,
    margin: '0 auto',

    '& p a': {
      color: '#73b944',
    },
  },
})

function ContentWrap({ children }) {
  const classes = useStyles()

  // global state
  const { globalState, dispatch } = useContext(Context)
  const { token, clubData, clubUserAgreementId, agreementVisible, agreementContent } =
    globalState
  const clubId = clubData.id

  // const handle agreement display close
  const onAgreementClose = () => {
    dispatch({ type: types.TOGGLE_AGGREEMENT })
  }

  useEffect(() => {
    // check if club already has agreement and use it's clubAgreementId
    const callGetClubUserAgreement = async (clubId) => {
      const waiverRes = await getClubUserAgreement(clubId);

      if (!waiverRes) {
        // if response is empty get new token and try again
        const { token } = getToken()
        dispatch({ type: types.UPDATE_TOKEN, payload: token })
        return null
      }

      dispatch({ type: types.UPDATE_AGREEMENT_ID, payload: waiverRes.id })
      dispatch({ type: types.SET_AGREEMENT_CONTENT, payload: waiverRes.content })
      return null
    }

    // add clubId to records
    if (clubId) {
      dispatch({ type: types.UPDATE_USER_DATA, payload: { clubId } })
    }

    // only trigger the call if token is already present
    if (clubId && token && !clubUserAgreementId) {
      callGetClubUserAgreement(clubId)
    }
  }, [clubId, token, dispatch, clubUserAgreementId])

  useEffect(() => {
    // toggle agreement display from iframe parent
    const messageHandler = (event) => {

      if (typeof event.data == 'object') {
        return;
      }
      let h = JSON.parse(event.data);
      if(h.openTerms) {
        dispatch({ type: types.TOGGLE_AGGREEMENT })
      }
    };
    window.addEventListener("message", messageHandler, false);
    return () => window.removeEventListener("message", messageHandler);
  }, [])

  return (
    <main className={classes.wrapper}>
      <Fade in={true} timeout={500} unmountOnExit>
        <div className={classes.content}>
          {children}
          <Loading />
        </div>
      </Fade>
      <Agreement
        open={agreementVisible}
        content={agreementContent}
        onClose={onAgreementClose}
      />
    </main>
  )
}

export default ContentWrap
